export const dividendsCalendarRoutes = {
  dividends: { proxy: 'calendar/dividends', upstream: 'v2.2/calendar/dividends' },
} as const;
